import { useSelector } from 'react-redux';

export const useActingAsUser = () => {
    const user = useSelector((state) => state.user);
    const actAsUser = user.original_admin?.id !== undefined ? user.id : null;

    return { user, actAsUser };
}; 